/**
 * Чисті хелпери rich-text опису (SPEC-008 §6.2).
 *
 * Винесені окремо від tiptap-компонентів, щоб покрити юніт-тестами БЕЗ рендеру
 * редактора: tiptap у jsdom тягне ProseMirror-DOM, а `@testing-library/react` у
 * проєкті немає (додавати не-tiptap залежність заборонено нарядом). Тому load-bearing
 * логіка — «порожній опис» — живе тут як чиста функція над HTML-рядком.
 */

/** Плейсхолдер поля опису (SPEC-008 §4). */
export const RICH_TEXT_PLACEHOLDER = 'Текст…'

/**
 * HTML → плоский текст: прибирає теги і найпоширеніші пробільні сутності.
 * Достатньо для перевірки непорожності; повного HTML-парсера тут не треба
 * (схему все одно валідує сам tiptap — StarterKit).
 */
export const stripHtmlToText = (html: string): string =>
    html
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/[\u00a0]/g, ' ')
        .trim()

/**
 * Порожній опис? Порожній рядок tiptap повертає як `<p></p>` — звичайний
 * `isRequired`-валідатор ядра вважав би це непорожнім. Тому емптіність рахуємо по
 * ТЕКСТУ, а не по HTML (заміна легасі-валідатора EditorJS-JSON, SPEC-008 §6.2).
 */
export const isRichTextEmpty = (html: string | null | undefined): boolean => {
    if (!html) return true
    return stripHtmlToText(html).length === 0
}

/**
 * Значення для збереження у полі `description`: порожній опис зводимо до `''`,
 * щоб ядровий `isRequired` спрацював, а бек не зберігав «порожній» `<p></p>`.
 */
export const normalizeRichTextValue = (html: string | null | undefined): string =>
    isRichTextEmpty(html) ? '' : (html as string)
